import React, { FunctionComponent, useMemo } from 'react';
import { FormState } from 'react-hook-form';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { ArrowBubbleError } from '../ArrowBubbleError';

interface FormFieldErrorProps {
  fieldName: string;
  formState: FormState<FieldValues>;
}

// FormFieldError displays an error message for a form field.  This is a wrapper around ArrowBubbleError that takes the
// field name and form state as props.
export const FormFieldError: FunctionComponent<FormFieldErrorProps> = ({ fieldName, formState }) => {
  if (!formState.errors[fieldName]) {
    return null;
  }

  const errorMessage = useMemo(
    () =>
      typeof formState?.errors?.[fieldName]?.message === 'string'
        ? (formState?.errors?.[fieldName]?.message as string)
        : 'Unknown error',
    [formState.errors[fieldName]]
  );

  return <ArrowBubbleError message={errorMessage} />;
};
